import compose from 'recompose/compose';
import branch from 'recompose/branch';
import mapProps from 'recompose/mapProps';
import lifecycle from 'recompose/lifecycle';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import renderComponent from 'recompose/renderComponent';
import WelcomePage from '../pages/main/welcome';
import * as browser from '../../util/cookie';

const COOKIE_NAME = 'TERMS_ACCEPTED';

const enhance = compose(
	withState('termsAcceptance', 'setTermsAccepted', false),
	lifecycle({
		componentDidMount() {
			const termsAccepted = browser.getCookie(COOKIE_NAME);

			this.props.setTermsAccepted(!!termsAccepted);
		}
	}),
	withHandlers({
		acceptTerms: props => () => {
			browser.setCookie(COOKIE_NAME, true, {path: '/'});
			props.setTermsAccepted(true);
		}
	}),
	branch(
		props => !props.termsAcceptance,
		renderComponent(WelcomePage)
	),
	mapProps(({termsAcceptance, setTermsAccepted, ...rest}) => ({...rest}))
);

export default enhance;



// WEBPACK FOOTER //
// ./src/client/routes/with-welcome-start.js